import React from "react";
import { buttonText, getTitleParaFun } from "../constants/ConstantsVariable";
import CheckListCompNew from "./shares/newCheckList";
import HeaderCompNew from "./shares/newHeaderComp";
import CommonButtonNew from "./shares/newCommonButton";

const ScreenOneComp = ({ startSubscriptionFun, onClick }) => {
   return (
      <>
         <HeaderCompNew text={getTitleParaFun(1)} />
         <div className="checklist-comp-new">
            <CheckListCompNew />
         </div>
         <div className="pg-button-container-new-ui pg-first-screen-button-margin">
            <div>
               <CommonButtonNew id="signUp-button-v2" btnText={buttonText(1)} onClick={onClick} loading={false} />
               <div className="pg-no-credit-card-text-new-ui">No credit card required</div>
            </div>

            <CommonButtonNew
               id="signUp-button-v2"
               btnText={buttonText()}
               onClick={startSubscriptionFun}
               loading={false}
               isWhiteBtn={true}
            />
         </div>
      </>
   );
};

export default ScreenOneComp;
